



































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import InlineSvg from 'vue-inline-svg';

@Component({
  components: { InlineSvg },
})
export default class Icon extends Vue {
  @Prop({ default: null })
  src: string;

  @Prop({ required: true })
  alt: string;

  @Prop({ default: null })
  fill: string;

  @Prop({ default: null })
  stroke: string;

  @Prop({ default: null })
  fillHover: string | null;

  @Prop({ default: null })
  strokeHover: string | null;

  @Prop({ default: 18 })
  height: number;

  @Prop({ default: 18 })
  width: number;

  @Prop({ default: 1 })
  padding: number;

  @Prop({ default: null })
  isParentHovering: boolean | null;

  @Prop({ default: '' })
  transform: string;

  isHovering = false;

  get hasHoverState() {
    return this.fillHover || this.strokeHover ? true : false;
  }

  @Watch('isParentHovering')
  isParentHoveringChange() {
    if (this.hasHoverState && typeof this.isParentHovering === 'boolean') {
      this.isHovering = this.isParentHovering;
    }
  }

  onIconHovered() {
    if (this.hasHoverState && typeof this.isParentHovering !== 'boolean') {
      this.isHovering = true;
    }
  }
  onIconUnhovered() {
    if (this.hasHoverState && typeof this.isParentHovering !== 'boolean') {
      this.isHovering = false;
    }
  }

  get imageSrc() {
    return this.src ? require(`@/assets/icon/${this.src}.svg`) : '';
  }
}
